<div class="dialog-container">
  <div class="text-container">
    <span class="font-medium-display-small text-align-center">
      Jetzt für Newsletter anmelden
    </span>
    <span class="font-regular-body-large text-align-center">
      Bleib immer up-to-date und hol dir wertvolle Infos rund um evidenzbasierte
      Therapie und praxisnahe Tipps zur Umsetzung! InWi versorgt dich regelmäßig
      mit den neuesten exklusiven Angeboten.
    </span>
  </div>
  <div class="action-container">
    <button
      type="button"
      class="inwi-text-button-large-primary align-self-stretch"
      [disabled]="isLoading"
      (click)="subscribe()">
      <div class="button-content">
        <div class="button-text">Jetzt abonnieren</div>
      </div>
    </button>
    <button
      type="button"
      class="inwi-text-button-large align-self-stretch"
      [disabled]="isLoading"
      (click)="dismiss()">
      <div class="button-content">
        <div class="button-text">Später</div>
      </div>
    </button>
  </div>
</div>
